module.exports = __webpack_public_path__ + "static/media/dragon-male.be878292.png";